import { render } from "./FriendlyCaptcha.vue?vue&type=template&id=72083d8b&scoped=true"
import script from "./FriendlyCaptcha.vue?vue&type=script&lang=js"
export * from "./FriendlyCaptcha.vue?vue&type=script&lang=js"

import "./FriendlyCaptcha.vue?vue&type=style&index=0&id=72083d8b&scoped=true&lang=css"

import exportComponent from "/builds/fr.swissLife.nxtCms/cms/nxtcms/nxt-front-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72083d8b"]])

export default __exports__